import React from 'react';
function CompetitionDiscordLink() {
  return (
    <a
      href="https://acmurl.com/ai-discord"
      target="_blank"
      rel="noopener noreferrer"
    >
      https://acmurl.com/ai-discord
    </a>
  );
}

export default CompetitionDiscordLink;
